import React from "react";
import FeatureCategory from "../../featurecategory";
import SEO from "../../seo";

export default function ReinforcedEdgeProtectionPage() {
  const categoryName = "Reinforced Edge Protection";

  const products = [
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Coil-on-Coil-1.png",
      name: "Coil On Coil",
      link: "/patent-series-mattress/coil-on-coil/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Tiara-Cool-1.png",
      name: "Tiara Cool",
      link: "/patent-series-mattress/tiara-cool/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Accolade.png",
      name: "Accolade PT",
      link: "/patent-series-mattress/accolade-pt/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Oslo-Plush12.png",
      name: "Healthsense ET",
      link: "/patent-series-mattress/healthsense-et/",
    },
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2021/06/Viena-1000X676.png",
      name: "VIENNA ET",
      link: "/patent-series-mattress/vienna-et/",
    },
  ];

  const categoryDescription = "<br/>";
  return (
    <div>
      <SEO
        title="Reinforced Edge Protection | Eclipse International"
        description=""
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-main.jpg"
      />
      <FeatureCategory
        products={products}
        categoryName={categoryName}
        categoryDescription={categoryDescription}
      />
    </div>
  );
}
